var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonServiceModificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.141,
    height: 14.014,
    viewBox: "0 0 13.141 14.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13901",
    "data-name": "Group 13901",
    transform: "translate(-18.93 -172.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7328",
    "data-name": "Path 7328",
    d: "M1268.914,80.411a3.344,3.344,0,1,1-3.35-3.337A3.335,3.335,0,0,1,1268.914,80.411Z",
    transform: "translate(-1240.186 95.602)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7329",
    "data-name": "Path 7329",
    d: "M1208.809,213.295h-4.352a2.486,2.486,0,0,1-1.276-.289,1.778,1.778,0,0,1-.92-1.581,9.2,9.2,0,0,1,.529-3.605,3.5,3.5,0,0,1,.763-1.22,2.2,2.2,0,0,1,1.516-.63.313.313,0,0,1,.163.058c.238.148.473.3.709.452a5.224,5.224,0,0,0,3.26.866,5.289,5.289,0,0,0,2.419-.809c.268-.167.53-.345.8-.508a.432.432,0,0,1,.234-.053,2.311,2.311,0,0,1,1.981,1.357,6.612,6.612,0,0,1,.685,2.447c.052.468.07.941.076,1.411a1.915,1.915,0,0,1-2.039,2.1c-1.516.016-3.032,0-4.549,0Z",
    transform: "translate(-1183.326 -26.607)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonServiceModificate);
export default __webpack_public_path__ + "static/media/person-service-modificate.dc844f0b68b2629fdfaa1e709ff72f8a.svg";
export { ForwardRef as ReactComponent };